import useTasksStore from '@/common/store/pinia/tasks';
import { useNotificationsStore } from '@/common/store/pinia/notifications';
import type {
  StoreOnActionListenerContext,
  StoreActions,
  StoreGetters,
  StoreState,
  StoreGeneric
} from 'pinia';
import useVhsTasksStore from '@/common/store/pinia/vhsTasks';

type Subscription<S extends StoreGeneric = StoreGeneric> = {
  store: S;
  actionsMap: {
    [K in keyof StoreActions<S>]?: (ctx: StoreOnActionListenerContext<S['$id'], StoreState<S>, StoreGetters<S>, StoreActions<S>>) => void;
  };
};

const subscribeToActions = <T extends readonly Subscription<any>[]>(
  subscriptions: T
): void => {
  subscriptions.forEach(({ store: piniaStore, actionsMap }: Subscription<any>) => {
    piniaStore.$onAction((ctx) => {
      actionsMap[ctx.name]?.(ctx);
    });
  });
};

export default () => {
  const notificationsStore = useNotificationsStore();

  subscribeToActions([
    {
      store: useTasksStore(),
      actionsMap: {
        fetchItems: ({ after }) => after(
          ({ data }) => data.forEach(task => notificationsStore.revealTask(task))
        ),
        fetchItem: ({ after }) => after(
          ({ data }) => notificationsStore.revealTask(data)
        ),
      }
    },
    {
      store: useVhsTasksStore(),
      actionsMap: {
        fetchItems: ({ after }) => after(
          ({ data }) => data?.data?.forEach(vhsTask => notificationsStore.revealVhsTask(vhsTask))
        ),
        fetchItem: ({ after }) => after(
          ({ data }) => notificationsStore.revealVhsTask(data)
        ),
      }
    }
  ]);
};
